import { render } from "./Comment.vue?vue&type=template&id=b3ffafd6&scoped=true&ts=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"

import "./Comment.vue?vue&type=style&index=0&id=b3ffafd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3ffafd6"]])

export default __exports__